module.exports = __webpack_public_path__ + "280037a76c7b3c3a5289073813de97cc.svg";